import * as React from 'react';
import { IconFunctionalHouse16, IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './NearbyNewbuildingsLink.css';
import { Link } from '../Link';

export interface INearbyNewbuildingsLinkProps {
  url: string;
  onClick(): void;
}

export const NearbyNewbuildingsLink: React.FC<INearbyNewbuildingsLinkProps> = (props: INearbyNewbuildingsLinkProps) => {
  const { url, onClick } = props;

  return (
    <Link url={url} target="blank" linkStyle={styles['link']} onClick={onClick}>
      <div className={styles['logo']}>
        <IconFunctionalHouse16 color={'icon-main-default'} />
      </div>
      <span className={styles['label']}>Другие ЖК рядом</span>
      <IconActionArrowUpRight16 color={'icon-main-default'} />
    </Link>
  );
};
